import { createFileRoute } from "@tanstack/react-router";

import { WalletPage } from "@/features/my/settings/account/billing/wallet";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/wallet/",
)({
  component: WalletPage,
});
